export default {
  nav: {
    search: 'Search Steam, PlayStation, Xbox...',
    cart: 'Cart',
  },
  hero: {
    s1: {
      platform: 'PlayStation Store',
      title: 'Top up your balance in minutes',
      desc: 'Cards from $5 to $100. Instant email delivery.',
      cta: 'Choose a card',
    },
    s2: {
      platform: 'Steam Wallet',
      title: 'Games, DLC and in-game items',
      desc: 'Steam Wallet top-up. Works for all regions.',
      cta: 'Top up Steam',
    },
    s3: {
      platform: 'Xbox Game Pass',
      title: 'Ultimate at a great price',
      desc: '100+ games, EA Play and cloud gaming in one subscription.',
      cta: 'Buy subscription',
    },
    stats: [
      { value: '15,000+', label: 'Happy customers' },
      { value: '< 5 min', label: 'Delivery time' },
      { value: '99.8%',   label: 'Success rate' },
      { value: '24/7',    label: 'Support' },
    ],
  },
  categories: {
    all:         'All',
    steam:       'Steam',
    playstation: 'PlayStation',
    xbox:        'Xbox',
    roblox:      'Roblox',
    fortnite:    'Fortnite',
    minecraft:   'Minecraft',
    gta:         'GTA Online',
  },
  badges: {
    hit:     'Hit',
    new:     'New',
    sale:    'Sale',
    popular: 'Popular',
    deal:    'Best deal',
  },
  sort: {
    label:     'Sort:',
    popular:   'Popular',
    priceAsc:  'Price ↑',
    priceDesc: 'Price ↓',
  },
  catalog: {
    title: 'Catalog',
    count: '{n} items',
    empty: {
      title: 'Nothing found',
      desc:  'Try a different query or category',
      reset: 'Reset filters',
    },
  },
  cta: {
    title: 'Need help choosing?',
    desc:  'Our support is online 24/7 and will help you pick the right amount',
    btn:   'Telegram',
  },
  cart: {
    title: 'Cart',
    empty: {
      title: 'Your cart is empty',
      desc:  'Add items from the catalog',
      btn:   'Browse catalog',
    },
    promo:    'Promo code',
    promoBtn: 'Apply',
    total:    'Total',
    checkout: 'Pay now',
    footer:   'Secure payment · Instant delivery',
  },
  accountForm: {
    title:    'Delivery Details',
    subtitle: 'Enter the account(s) where you want to receive the top-up',
    email:    { label: 'Receipt email', placeholder: 'email address' },
    continue: 'Continue to payment',
    required: 'Please fill in all fields',
    fields: {
      steam:       { label: 'Steam Login',      placeholder: 'Username or profile URL' },
      playstation: { label: 'PSN ID',            placeholder: 'Your PSN username' },
      xbox:        { label: 'Xbox Gamertag',      placeholder: 'Your Xbox gamertag' },
      roblox:      { label: 'Roblox Username',    placeholder: 'Your Roblox username' },
      fortnite:    { label: 'Epic Games Email',   placeholder: 'email address' },
      minecraft:   { label: 'Minecraft Username', placeholder: 'Your Minecraft username' },
      gta:         { label: 'Rockstar Account',   placeholder: 'Email or Social Club name' },
    },
  },
  success: {
    title:    'Payment Successful!',
    subtitle: 'Your order has been paid',
    desc:     'The top-up will be credited to your account within a few minutes. Check your email for the receipt.',
    close:    'Great, thanks!',
  },
  payment: {
    title:   'Secure Payment',
    loading: 'Initializing payment…',
    error:   'Payment error',
    retry:   'Try again',
    close:   'Close',
  },
  howItWorks: {
    title: 'How it works',
    steps: [
      { icon: 'search', title: 'Choose a product', desc: 'Browse the catalog and pick the top-up or gift card you need' },
      { icon: 'pay',    title: 'Pay securely',     desc: 'Complete checkout in seconds via our encrypted payment widget' },
      { icon: 'email',  title: 'Get it instantly', desc: 'Your code or top-up arrives to your email within minutes' },
    ],
  },
  modal: {
    addToCart: 'Add to Cart',
    buyNow:    'Buy Now',
    includes:  'What\'s included',
    region:    'Region',
    delivery:  'Instant delivery after payment',
  },
  products: {
    p1:  { description: 'Add $5 to your Steam Wallet and spend it on games, DLC, and in-game items across the entire Steam catalog.', features: ['Instant delivery to your account', 'Works for all games & DLC', 'Compatible with CS2, Dota 2 & more', 'No expiration date'] },
    p2:  { description: 'Our most popular Steam top-up. $10 opens thousands of games in the Steam catalog at a great price.', features: ['Instant delivery to your account', 'Works for all games & DLC', 'Compatible with CS2, Dota 2 & more', 'No expiration date'] },
    p3:  { description: 'Top up your Steam Wallet with $20 and enjoy a wider selection of games, season passes, and exclusive items.', features: ['Instant delivery to your account', 'Works for all games & DLC', 'Compatible with CS2, Dota 2 & more', 'No expiration date'] },
    p4:  { description: 'Add $10 to your PSN wallet and explore hundreds of games, movies, and add-ons for PS4 and PS5.', features: ['Instant top-up to PSN account', 'Works on PS4 and PS5', 'Buy games, DLC, PS Plus & more', 'Region: Global'] },
    p5:  { description: 'Get $25 for your PlayStation Network wallet at a great discount. Perfect for new AAA releases or PS Plus.', features: ['Instant top-up to PSN account', 'Works on PS4 and PS5', 'Buy games, DLC, PS Plus & more', 'Region: Global'] },
    p6:  { description: 'PlayStation Plus Essential gives you monthly free games, online multiplayer, and exclusive PS Store discounts.', features: ['Online multiplayer access', '2–3 free games every month', 'Exclusive PS Store discounts', 'Cloud storage for game saves'] },
    p7:  { description: 'Add $10 to your Microsoft account and spend it on Xbox games, DLC, and subscriptions from the Microsoft Store.', features: ['Works on Xbox & PC (Microsoft Store)', 'Buy games, movies & apps', 'Use toward Xbox Game Pass', 'No expiration date'] },
    p8:  { description: 'Xbox Game Pass Ultimate includes 100+ games, EA Play membership, and Xbox Cloud Gaming — all in one subscription.', features: ['100+ games on console & PC', 'EA Play included at no extra cost', 'Xbox Cloud Gaming — stream anywhere', 'Day-one access to new Xbox releases'] },
    p9:  { description: 'Robux is the in-game currency of Roblox. Use 800 Robux to buy avatar items, game passes, and premium upgrades.', features: ['Credited instantly to your account', 'Works in any Roblox game', 'Buy avatar accessories & clothing', 'Upgrade game passes & memberships'] },
    p10: { description: 'Get 2000 Robux at a great price and unlock more of what Roblox has to offer — rare items, exclusive game passes, and more.', features: ['Credited instantly to your account', 'Works in any Roblox game', 'Buy avatar accessories & clothing', 'Upgrade game passes & memberships'] },
    p11: { description: 'V-Bucks are the Fortnite in-game currency. Use 1000 V-Bucks to buy skins, emotes, pickaxes, and the Battle Pass.', features: ['Works on PC, PS4/5, Xbox, Switch & Mobile', 'Buy outfits, emotes & wraps', 'Unlock the Battle Pass', 'No expiration date'] },
    p12: { description: 'Stock up on 2800 V-Bucks and grab multiple bundles, skins, and the full Battle Pass — with currency left over.', features: ['Works on PC, PS4/5, Xbox, Switch & Mobile', 'Buy outfits, emotes & wraps', 'Unlock the Battle Pass', 'No expiration date'] },
    p13: { description: 'The original Minecraft Java Edition — build, explore, and survive in infinite worlds. Moddable and community-driven.', features: ['Permanent full game license', 'All future free updates included', 'Thousands of community mods', 'Multiplayer on public & private servers'] },
    p14: { description: 'The Bull Shark Card adds $1,000,000 GTA$ to your GTA Online account — grab vehicles, weapons, and properties.', features: ['$1,000,000 GTA$ added instantly', 'Available on PS4, PS5, Xbox & PC', 'Buy cars, apartments & weapons', 'No time limit to spend'] },
    p15: { description: 'The Megalodon Shark Card adds $8,000,000 GTA$ — enough for supercars, a yacht, and a luxury penthouse in Los Santos.', features: ['$8,000,000 GTA$ added instantly', 'Available on PS4, PS5, Xbox & PC', 'Best-value Shark Card available', 'No time limit to spend'] },
  },
  footer: {
    desc: 'Instant top-up for Steam, PlayStation, Xbox and other gaming platforms.',
    cols: [
      { title: 'Catalog',     items: ['Steam', 'PlayStation', 'Xbox', 'Roblox', 'Fortnite'] },
      { title: 'Information', items: ['How it works', 'Guarantees', 'Reviews', 'Blog'] },
      { title: 'Support',     items: ['FAQ', 'Contact us', 'Refund policy', 'Terms of service'] },
    ],
    rights: '© 2025 GamePay. All rights reserved.',
  },
}
